module.exports = __webpack_public_path__ + "static/media/TT.4de7eead.png";